import styled from "styled-components";

export const BullpenDisplayContainer = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    height: 100%;
    position: relative;
    width: 50%;
    flex-shrink: 0;
    padding-left: 24px;
    padding-bottom: 16px;
    min-height: 614px;
`
export const Bullpen = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 48px;
    width: 100%;
`
export const BullpenCardsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    width: 448px;
    justify-content: flex-start;
`
export const CardGroupContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;

    h2 {
        font-family: 'Roboto Condensed';
        font-size: 24px;
        opacity: 0.8;
    }

    @media (max-width: 768px) {
        gap: 10px;

        h2 {
            font-size: 20px;
        }
    }

    @media (max-width: 480px) {
        gap: 8px;

        h2 {
            font-size: 18px;
        }
    }
`